import React from "react";
import "./style.scss";

interface HealthRelevanceBadgeProps {
  type: "health" | "relevance";
  flag: "R" | "Y" | "G" | "H" | "M" | "L";
  label?: string;
  organizationName?: string;
  className?: string;
}

export const HealthRelevanceBadge: React.FC<HealthRelevanceBadgeProps> = ({
  type,
  flag,
  label,
  organizationName,
  className = "",
}) => {
  const getHealthText = (flag: string): string => {
    switch (flag) {
      case "G":
        return "GREEN";
      case "Y":
        return "YELLOW";
      case "R":
        return "RED";
      default:
        return "N/A";
    }
  };

  const getRelevanceText = (flag: string): string => {
    switch (flag) {
      case "H":
        return "HIGH";
      case "M":
        return "MEDIUM";
      case "L":
        return "LOW";
      default:
        return "N/A";
    }
  };

  const getHealthStyles = (flag: string): React.CSSProperties => {
    switch (flag) {
      case "G":
        return { background: "#16a34a", color: "white" };
      case "Y":
        return { background: "#d97706", color: "white" };
      case "R":
        return { background: "#dc2626", color: "white" };
      default:
        return { background: "#6b7280", color: "white" };
    }
  };

  const getRelevanceStyles = (flag: string): React.CSSProperties => {
    switch (flag) {
      case "H":
        return { background: "#8b5cf6", color: "white" };
      case "M":
        return { background: "#d97706", color: "white" };
      case "L":
        return { background: "#6b7280", color: "white" };
      default:
        return { background: "#6b7280", color: "white" };
    }
  };

  if (type === "health") {
    const text = label || getHealthText(flag);
    const styles = getHealthStyles(flag);

    return (
      <div className={`health-badge ${className}`} style={styles}>
        <span className="badge-label">Account Health:</span>
        <span className="badge-value">{text}</span>
      </div>
    );
  } else {
    const text = label || getRelevanceText(flag);
    const styles = getRelevanceStyles(flag);
    const orgName = organizationName || "Organization";

    return (
      <div className={`relevance-badge ${className}`} style={styles}>
        <span className="badge-label">Relevance to {orgName}:</span>
        <span className="badge-value">{text}</span>
      </div>
    );
  }
};
